/* tslint:disable */
/* eslint-disable */
/**
 * DynamicForms.Server | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EmailAddressComponentFromJSON, EmailAddressComponentToJSON, } from './EmailAddressComponent';
/**
 * Check if a given object implements the EmailConfigComponent interface.
 */
export function instanceOfEmailConfigComponent(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('userEmailTemplateId' in value) || value['userEmailTemplateId'] === undefined)
        return false;
    if (!('adminEmailTemplateId' in value) || value['adminEmailTemplateId'] === undefined)
        return false;
    if (!('userEmailSubject' in value) || value['userEmailSubject'] === undefined)
        return false;
    if (!('adminEmailSubject' in value) || value['adminEmailSubject'] === undefined)
        return false;
    if (!('from' in value) || value['from'] === undefined)
        return false;
    if (!('admins' in value) || value['admins'] === undefined)
        return false;
    return true;
}
export function EmailConfigComponentFromJSON(json) {
    return EmailConfigComponentFromJSONTyped(json, false);
}
export function EmailConfigComponentFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'userEmailTemplateId': json['userEmailTemplateId'],
        'adminEmailTemplateId': json['adminEmailTemplateId'],
        'userEmailSubject': json['userEmailSubject'],
        'adminEmailSubject': json['adminEmailSubject'],
        'from': EmailAddressComponentFromJSON(json['from']),
        'replyTo': json['replyTo'] == null ? undefined : (json['replyTo'].map(EmailAddressComponentFromJSON)),
        'admins': (json['admins'].map(EmailAddressComponentFromJSON)),
    };
}
export function EmailConfigComponentToJSON(json) {
    return EmailConfigComponentToJSONTyped(json, false);
}
export function EmailConfigComponentToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'userEmailTemplateId': value['userEmailTemplateId'],
        'adminEmailTemplateId': value['adminEmailTemplateId'],
        'userEmailSubject': value['userEmailSubject'],
        'adminEmailSubject': value['adminEmailSubject'],
        'from': EmailAddressComponentToJSON(value['from']),
        'replyTo': value['replyTo'] == null ? undefined : (value['replyTo'].map(EmailAddressComponentToJSON)),
        'admins': (value['admins'].map(EmailAddressComponentToJSON)),
    };
}
